import React from 'react';

import { InfoProps } from '../../types';

import { CgClose } from "react-icons/cg";

import { unHighlightNodes } from '../../util/d3/highlightNodes';

import '../../styles/InfoBox.css';

/*
* Possibly a temporary fix for ä and ö should the coreinitdummy
* differ from the one got from the Hailer backend
*/

const Element = ({ phaseName }: { phaseName: string }): JSX.Element => (
  <p>
    {phaseName ?? 'Unknown phase'}
  </p>  
);

/* 
* Variable 'node' is the id for the clicked (active) node
* for which the infobox is rendered
*/

const InfoBox = ({ data, node, setNode }: InfoProps) => { 
  
  const foundNode = data['nodes'].find(no => (no['id'] === node));
  
  const nodeName = foundNode?.name ?? '';

  /**
   * Parses an array consisting of the Phases of a node
   * @returns an Array
   */

  const getPhases = () => {
    const map = foundNode?.phases;
    if(map){
      const arrayOfPhases = map.map((phase) => phase.name);
      return arrayOfPhases;
    }
    return null;
  };

  const close = () => {
    setNode('');
    unHighlightNodes();
  };

  if(nodeName === '') {
    return null;
  }

  const phases = getPhases();

  return (
    <div className='be_InfoBox'>
      <div className="be_closeDot">
        <CgClose className='be_close-button' onClick={() => close()}/>
      </div>  
      <h3 className='be_header'> {nodeName} </h3>
      <div className='be_phases'>
        <p><b>Phases:</b></p>
          {phases 
          ? phases?.map((phase, index) => <Element key={index} phaseName={phase} />) 
          : 'No node information'}
      </div>
    </div>
  );
};

export default InfoBox;
